import { useEffect, useState } from 'react';
import { createClient } from '@supabase/supabase-js';

const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_CLIENT_ANON_KEY
);

const MAX_SPOTS = 1000;

export default function WaitlistForm() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [spotsLeft, setSpotsLeft] = useState(null);

  useEffect(() => {
    const fetchCount = async () => {
      const { count, error } = await supabase
        .from('waitlist')
        .select('*', { count: 'exact', head: true });

      if (!error) {
        setSpotsLeft(Math.max(0, MAX_SPOTS - count));
      } else {
        console.error('[❌] Failed to load waitlist count:', error.message);
      }
    };

    fetchCount();
  }, [submitted]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email) {
      setError('Please enter your email.');
      return;
    }

    const { error } = await supabase.from('waitlist').insert([{ email }]);

    if (error) {
      console.error('[❌] Error:', error.message);
      setError('Failed to submit. Please try again.');
    } else {
      setSubmitted(true);
    }
  };

  return (
    <div>
      <div className="p-4">
        <video
          className="absolute object-cover w-full h-auto aspect-[16/9] z-[0] top-0 left-0"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src="/videos/pre.mp4" type="video/mp4" />
        </video>
      </div>
      <div className="fixed flex items-center justify-center bg-gradient-to-tr from-50% from-zinc-950/95 to-zinc-950/0 top-0 left-0 w-full h-full mx-auto p-6 bg-transparent text-white rounded-lg shadow-lg z-0">
        {submitted ? (
          <p className="text-green-400 text-center text-xl">
            ✅ Thanks! We'll be in touch soon.
          </p>
        ) : (
          <div className="max-w-3xl">
            <h1 className="text-6xl font-light leading-11 text-center">
              Be like a pro. On X, Anywhere.
            </h1>
            <p className="text-lg font-thin text-center mb-4">
              Ditch After Effects. Ten hours? Try ten clicks. Rodeomotion makes animated mockups stupidly fast.
            </p>
            <form
              onSubmit={handleSubmit}
              className="flex flex-col gap-4 max-w-md mx-auto"
            >
              <input
                id="email"
                type="email"
                className="p-3 rounded-2xl bg-zinc-950/70 backdrop-blur-md border border-zinc-700 focus:outline-none"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="e.g. jane@email.com"
                required
              />
              <button
                type="submit"
                className="bg-blue-700 hover:bg-blue-600 text-white py-3 px-4 rounded-2xl transition"
              >
                Join the waitlist
              </button>
              {error && <p className="text-red-400 text-sm">{error}</p>}
            </form>
            {spotsLeft !== null && (
              <p className="text-sm font-light text-center text-zinc-300 mt-4">
                {spotsLeft > 0
                  ? `${spotsLeft} spots left. First ${MAX_SPOTS} users get 1 year free access.`
                  : 'The free access limit has been reached. New users will be notified when paid access launches.'}
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
